import Dexie, { type Table } from 'dexie';

export interface OutboxOperation {
  id: string;
  userId: string;
  entityType: string;
  entityId: string;
  op: 'upsert' | 'delete';
  payload: unknown;
  createdAt: string;
  updatedAt: string;
  idempotencyKey: string;
  attempts: number;
  status: string;
  bytes: number;
  schemaVersion: number;
}

export interface QuarantineRecord {
  id: string;
  userId: string;
  entityType: string;
  entityId: string;
  op: string;
  payload: unknown;
  error: string;
  reason: string;
  bytes: number;
  schemaVersion: number;
  status: string;
  recoveredAt: string | null;
  discardedAt: string | null;
  createdAt: string;
}

export interface ConflictRecord {
  id: string;
  userId: string;
  entityType: string;
  entityId: string;
  localPayload: unknown;
  remotePayload: unknown;
  localVersion: number;
  remoteVersion: number;
  localUpdatedAt: string;
  remoteUpdatedAt: string;
  resolution: string;
  createdAt: string;
  resolvedAt?: string | null;
}
import type {
  Node,
  NodeTemplate,
  MacroSession,
  ProblemAttempt,
  RecallItem,
  ReviewEvent,
  MemoryWeights,
  Conjecture,
  SleepRecord,
  StudyGoal
} from '$domain/types';

export class StudyQuantifierDB extends Dexie {
  nodes!: Table<Node, string>;
  nodeTemplates!: Table<NodeTemplate, string>;
  macroSessions!: Table<MacroSession, string>;
  problemAttempts!: Table<ProblemAttempt, string>;
  recallItems!: Table<RecallItem, string>;
  reviewEvents!: Table<ReviewEvent, string>;
  memoryWeights!: Table<MemoryWeights, string>;
  conjectures!: Table<Conjecture, string>;
  sleepRecords!: Table<SleepRecord, string>;
  studyGoals!: Table<StudyGoal, string>;
  preferences!: Table<any, string>;
  outbox!: Table<any, string>;
  quarantine!: Table<any, string>;
  syncMeta!: Table<any, string>;
  migrationLog!: Table<any, string>;
  conflicts!: Table<any, string>;
  leaderboardEntries!: Table<any, string>;

  constructor() {
    super('StudyQuantifierDB');
    this.version(6).stores({
      nodes: 'id, userId, parentId, type, [userId+parentId]',
      nodeTemplates: 'id, userId',
      macroSessions: 'id, userId, nodeId, status, startedAt',
      problemAttempts: 'id, userId, macroSessionId, nodeId',
      recallItems: 'id, userId, nodeId, state, nextReviewAt',
      reviewEvents: 'id, userId, recallItemId',
      memoryWeights: 'id, userId, nodeId',
      conjectures: 'id, userId, nodeId, sessionId',
      sleepRecords: 'id, userId, date',
      studyGoals: 'id, userId',
      preferences: 'key',
      outbox: 'id, userId, entityType, entityId',
      quarantine: 'id, userId',
      syncMeta: 'key',
      migrationLog: 'id',
      conflicts: 'id, userId',
      leaderboardEntries: 'id, userId'
    });
  }
}

export const db = new StudyQuantifierDB();